import { createTheme } from '@mui/material/styles';
import { colors } from './lib/styles';

const theme = createTheme({
  typography: {
    useNextVariants: true,
    fontFamily: 'Source Sans Pro, Roboto, sans-serif',
    h1: {
      fontFamily: 'Cormorant Garamond, Georgia, Times New Roman, serif',
      margin: '15px',
    },
    h2: {
      fontFamily: 'Cormorant Garamond, Georgia, Times New Roman, serif',
      margin: '15px',
    },
    h3: {
      fontFamily: 'Cormorant Garamond, Georgia, Times New Roman, serif',
      margin: '15px',
    },
    h4: {
      fontFamily: 'Cormorant Garamond, Georgia, Times New Roman, serif',
      margin: '15px',
    },
    h5: {
      fontFamily: 'Cormorant Garamond, Georgia, Times New Roman, serif',
      margin: '15px',
    },
    h6: {
      fontFamily: 'Cormorant Garamond, Georgia, Times New Roman, serif',
      margin: '15px',
    },
    body1: {
      fontFamily: 'Source Sans Pro, Roboto, sans-serif',
      fontSize: 18,
    },
  },
  palette: {
    primary: {
      main: '#4F5F4B',
      contrastText: '#FDFAF6',
    },
    secondary: {
      main: '#8A6F45',
      contrastText: '#FDFAF6',
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        variant: 'contained',
      },
      styleOverrides: {
        root: {
          fontFamily: 'Cormorant Garamond, Georgia, Times New Roman, serif',
          fontSize: 18,
          '&.Mui-disabled': {
            background: colors.blackOpacity,
          },
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          fontFamily: 'Source Sans Pro, Roboto, sans-serif',
          '& .MuiDataGrid-mainGridContainer': {
          },
          '& .MuiTablePagination-selectLabel': {
            fontFamily: 'Source Sans Pro, Roboto, sans-serif',
          },
          '& .MuiTablePagination-select': {
            fontFamily: 'Source Sans Pro, Roboto, sans-serif',
          },
          '& .MuiTablePagination-displayedRows': {
            fontFamily: 'Source Sans Pro, Roboto, sans-serif',
          },
          '& .MuiMenuItem-root': {
            fontFamily: 'Source Sans Pro, Roboto, sans-serif',
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: 18,
          padding: '4px 10px !important',
        },
        root: {
          height: '45px',
        },
      },
    },
  },
});

export default theme;
